const partTypeFilterHelpers = {
	getAdditionalFilterValuesFromDom: function() {
		const $partTypeFilter = rp$('.part-type-filter-form');
		const parsedFilters = {};

		$partTypeFilter.children().each((i, filter) => {
			if (filter.classList.contains('select-filter-wrapper')) {
				const select = rp$(filter).find('select');
				if (!select.length) {
					const radioGroup = rp$(filter).find('.radio-group-filter');
					if (radioGroup.length) {
						const radioGroupInput = radioGroup.find('.radio-group-input input:checked');
						if (radioGroupInput.length) {
							parsedFilters[radioGroup[0].getAttribute('data-query-name')] = radioGroupInput.val();
						}
					}
					return;
				}
				const selectedValue = select.val();
				parsedFilters[select[0].getAttribute('data-query-name')] = selectedValue;
			}
		});

		return parsedFilters;
	},
	findMainModule: function() {
		const oemLevelCategoriesModule = rp$('.oem-top-level-categories-module');
		if (oemLevelCategoriesModule.length) {
			return oemLevelCategoriesModule;
		}
		const topLevelCategoriesModule = rp$('.top-selling-categories-module');
		if (topLevelCategoriesModule.length) {
			return topLevelCategoriesModule;
		}

		const searchListingModule = rp$('.search-listing-module');
		if (searchListingModule.length) {
			return searchListingModule;
		}

		const oemAssembliesModule = rp$('.oem-assemblies-module');
		if (oemAssembliesModule.length) {
			return oemAssembliesModule;
		}

		return [];
	},
	validatePartType: function() {
		const args = rp_app.query.all(rp_app.location.href);
		const brandType = args ? args.brandType : null;
		if (brandType) {
			rp$('select[data-query-name="brandType"]').each((_, select) => {
				rp$(select).val(brandType);
			});
			rp$('div[data-query-name="brandType"]').each((_, radioGroup) => {
				const radioGroupInput = rp$(radioGroup).find(`input[value="${brandType}"]`);
				rp$(radioGroup).find('input').removeAttr('checked');
				rp$(radioGroupInput).attr('checked', 'checked');
				rp$(radioGroupInput).prop('checked', true);
			});
		}
	},
	showSpinner: function() {
		const mainModule = this.findMainModule();
		const spinner = mainModule.find('.spinner-wrap');
		if (spinner.length) {
			spinner.show();
		} else {
			mainModule.overlaySpinner({animation:{top: '200px'}});
		}
	},
	hideSpinner: function() {
		const mainModule = this.findMainModule();
		const spinner = mainModule.find('.spinner-wrap');
		if (spinner.length) {
			spinner.hide();
		}
		this.validatePartType();
	}

};

module.exports = partTypeFilterHelpers;
